import { useMemo } from "react";

import { UIContext } from "common/contexts/UIContext";

import { urls } from "client/routes";
import { useClinic, useFeatures } from "client/clinics/hooks";

type ClientUIProviderProps = {
  children: React.ReactNode;
};

const ClientUIProvider = (props: ClientUIProviderProps) => {
  const { children } = props;

  const clinic = useClinic();
  const tag = clinic.primary_tag;
  const features = useFeatures();

  const value = useMemo(() => {
    const isPimsUI = tag.is_pims_ui_enabled && tag.is_pims_backend_enabled;
    const clinicGroupCountry = clinic.group.country;
    const isHdEnabled = tag.is_hd_enabled;

    return {
      isPimsUI,
      isV2UI: isPimsUI || features.HD_UI_V2,
      isHdEnabled,
      clinicGroupCountry,
      homeUrl: urls.home.root.to(),
    };
  }, [
    clinic.group.country,
    tag.is_hd_enabled,
    tag.is_pims_ui_enabled,
    tag.is_pims_backend_enabled,
    features.HD_UI_V2,
  ]);

  return <UIContext.Provider value={value}>{children}</UIContext.Provider>;
};

export default ClientUIProvider;
